import config from "src/config";
import { getRequestHeaders } from "./common.service";
import axios from "./axios.service";

async function getActions(queryParams = {}) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/actions', { headers: headers, params: queryParams });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function getAction(actionId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/actions/' + actionId, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateActionStatus(actionId, status) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/actions/' + actionId + '/status', { status: status }, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

export {
    getActions,
    getAction,
    updateActionStatus,
}
